import {message} from '@sail/intl';

export const sectionTitle = message({
  id: 'mkt-ssr.startup_partners.leading_startup_section.title',
  defaultMessage: 'Trusted by leading startups',
  description: 'Title for the leading startups section',
});

export const sectionBody = message<{partnerName: string}>({
  id: 'mkt-ssr.startup_partners.leading_startup_section.body',
  defaultMessage:
    "We partner with {partnerName} to provide custom benefits to accelerate your company's growth. Whether you're building a SaaS business, an on-demand marketplace, a modern ecommerce company, or something entirely new, Stripe's integrated platform is designed to help you build and scale your business online.",
  description: 'Body text for the leading startups section',
});
